import campaign from './campaign';
export * from './campaign';

export default { campaign };
